export type RsvpStatus = 'going' | 'maybe' | 'cant' | null

export interface PortalEvent {
  id: string
  title: string
  /** Human date, since nothing here is scheduled programmatically. */
  date: string
  time: string
  place: string
  city: string
  blurb: string
  host: string
  /** Members who have said they're going, by public name. */
  going: string[]
  maybe: string[]
  /** Set when the event is aimed at a particular stretch of years. */
  era?: string
}

export const EVENTS: PortalEvent[] = [
  {
    id: 'reunion-2026',
    title: 'Tile wall ceremony',
    date: 'Saturday, December 5, 2026',
    time: 'Time TBD',
    place: 'The Stone, courtyard',
    city: 'San Diego',
    blurb:
      'The fiftieth anniversary tiles join the wall. Come see your year, or someone else’s, set in stone.',
    host: 'Stepping Stone',
    going: ['Marion A.', 'Theresa M.', 'Ken D.', 'Nadia K.', 'Sam O.', 'Howard P.'],
    maybe: ['Lorna B.', 'Andre P.'],
  },
  {
    id: 'nineties-coffee',
    title: 'Coffee for the 1990s',
    date: 'Thursday, October 15, 2026',
    time: '10:00–11:30am',
    place: 'A coffee shop in Hillcrest (details on RSVP)',
    city: 'San Diego',
    blurb:
      'Informal, no program. Started by two members who realized they had been in the Tuesday group eighteen months apart and never met.',
    host: 'Theresa M.',
    era: '1990s',
    going: ['Theresa M.', 'Lorna B.', 'Anita C.'],
    maybe: ['Howard P.'],
  },
  {
    id: 'scanning-night',
    title: 'Scanning night',
    date: 'Wednesday, October 21, 2026',
    time: '6:00–8:30pm',
    place: 'The Stone, group room',
    city: 'San Diego',
    blurb:
      'Bring anything on paper: photographs, flyers, newsletters, a program from a night you remember. We scan it, hand it straight back, and you keep the original.',
    host: 'Marion A.',
    going: ['Marion A.', 'Nadia K.'],
    maybe: [],
  },
  {
    id: 'volunteer-call',
    title: 'Portal volunteers, monthly call',
    date: 'Tuesday, October 6, 2026',
    time: '7:00–7:45pm',
    place: 'Online',
    city: 'Anywhere',
    blurb:
      'What the archive group is working on, and what needs hands. No commitment. People come once and never again, which is fine.',
    host: 'The archive group',
    going: ['Marion A.', 'Sam O.'],
    maybe: ['Marcus J.'],
  },
]

export const PAST_EVENTS: { title: string; date: string; note: string }[] = [
  {
    title: '50th Anniversary Pink Gala',
    date: 'April 2026',
    note: 'The Lambda Archives history exhibit debuted here. Photographs from it are in the archive.',
  },
  {
    title: 'Coffee for the 1980s',
    date: 'May 2026',
    note: 'Six people, two of whom had not seen each other since 1987.',
  },
]
